var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDollarSign = function SvgDollarSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "dollar-sign_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1v22M17 5H9.5a3.5 3.5 0 1 0 0 7h5a3.5 3.5 0 1 1 0 7H6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgDollarSign as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTIgMVYyMyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PHBhdGggZD0iTTE3IDVIOS41QzguNTcxNzQgNSA3LjY4MTUgNS4zNjg3NSA3LjAyNTEzIDYuMDI1MTNDNi4zNjg3NSA2LjY4MTUgNiA3LjU3MTc0IDYgOC41QzYgOS40MjgyNiA2LjM2ODc1IDEwLjMxODUgNy4wMjUxMyAxMC45NzQ5QzcuNjgxNSAxMS42MzEzIDguNTcxNzQgMTIgOS41IDEySDE0LjVDMTUuNDI4MyAxMiAxNi4zMTg1IDEyLjM2ODcgMTYuOTc0OSAxMy4wMjUxQzE3LjYzMTMgMTMuNjgxNSAxOCAxNC41NzE3IDE4IDE1LjVDMTggMTYuNDI4MyAxNy42MzEzIDE3LjMxODUgMTYuOTc0OSAxNy45NzQ5QzE2LjMxODUgMTguNjMxMyAxNS40MjgzIDE5IDE0LjUgMTlINiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+";